import { render } from "./ActivityButton.vue?vue&type=template&id=a6669da4&scoped=true"
import script from "./ActivityButton.vue?vue&type=script&lang=js"
export * from "./ActivityButton.vue?vue&type=script&lang=js"

import "./ActivityButton.vue?vue&type=style&index=0&id=a6669da4&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6669da4"]])

export default __exports__